import { useNavigate } from "react-router-dom";
import { useContext, useState, useRef, useEffect } from "react";
import { AuthContext } from "../../Context/AuthContext"; 
import useCategories from "../../Lib/usefetchCategories";  
import 'react-loading-skeleton/dist/skeleton.css'; 
import { ReactComponent as VatugIcon } from "../../Asset/black.svg";
import "./createvessel.css";
import { HiX } from 'react-icons/hi';
import { HiArrowLeft } from 'react-icons/hi';

const CreateVessel = () => {
  const { vesselType, setVesselType } = useContext(AuthContext);
  const navigate = useNavigate();
  
  const { data: categoriesResponse, isLoading, error } = useCategories();
  const categories = categoriesResponse?.data || [];
  
  // Custom dropdown state
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  // Filter categories based on search term
  const filteredCategories = categories.filter(category => 
    category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Toggle dropdown
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Handle category selection
  const handleCategorySelect = (category) => {
    setVesselType(category);
    setIsDropdownOpen(false);
    setSearchTerm("");
    
    // Force state update to ensure dropdown closes
    setTimeout(() => {
      setIsDropdownOpen(false);
    }, 0);
  };

  const handleGoBack = () => {
    navigate("/dashboard/myvessels");
  };

  const handleNext = () => {
    localStorage.setItem("selectedVesselType", vesselType);
    navigate("/vessel_infomation");
  };

  return (
    <div className="create-vessel-container">
      <div className="create-vessel-header-bar">
        <div className="logo-container">
          <VatugIcon />
          <div className="logo-underline"></div>
        </div>
        <div className="title">Vessel Upload</div>
        <button className="close-btn" onClick={handleGoBack}> <HiX /> </button>
      </div>
      <div className="create-vessel-card">
        <h2>Select vessel type</h2>
        <p>Make sure that the information you enter can also be found in any of your valid government IDs.</p>
        <label>
          Vessel Type
          <div className="custom-select-container" ref={dropdownRef}>
            <button 
              type="button"
              className="custom-select-button"
              onClick={toggleDropdown}
            >
              {vesselType || "Select"}
            </button>
            {isDropdownOpen && (
              <div className="custom-select-dropdown show">
                <div className="custom-select-search">
                  <input
                    type="text"
                    placeholder="Search vessel type..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
                {isLoading ? (
                  <div className="custom-select-option">Loading...</div>
                ) : error ? (
                  <div className="custom-select-option">Error loading vessel types</div>
                ) : filteredCategories.length > 0 ? (
                  filteredCategories.map((category) => (
                    <div
                      key={category}
                      className={`custom-select-option ${vesselType === category ? 'selected' : ''}`}
                      onClick={() => handleCategorySelect(category)}
                    >
                      {category}
                    </div>
                  ))
                ) : (
                  <div className="custom-select-option">No vessel types found</div>
                )}
              </div>
            )}
          </div>
        </label>
        <div className="vessel-note"><span className="asterisk">*</span><em>you would be required to upload  a certificate based on the type of vessel selected</em></div>
        <div className="button-row">
          <button className="back-btn" onClick={handleGoBack}><HiArrowLeft style={{marginRight: 6}}/> Go Back</button>
          <button className="next-btn" onClick={handleNext} disabled={!vesselType}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default CreateVessel;

